import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto, MaterialPublicDto, ProductQuantityValidationPublicDto } from "@sticker-giant/sg-frontend-common";
import { useQuantitiesForAllProducts } from "./useQuantitiesForAllProducts";
interface QuantitiesForItem {
  quantities?: ProductQuantityValidationPublicDto;
  materialOption?: MaterialPublicDto;
  presetQuantities?: number[];
  isLoading: boolean;
}
export function useQuantitiesForItem(item) {
  const $ = _c(10);
  const {
    data: quantitiesForAllProducts,
    isLoading
  } = useQuantitiesForAllProducts();
  let materialOption;
  let quantities;
  let t0;
  if ($[0] !== item || $[1] !== quantitiesForAllProducts) {
    quantities = quantitiesForAllProducts?.find(entry => entry.sku === item.sku.marketingName);
    materialOption = quantities?.materialOptions.find(option => option.sku === item.sku.material);
    t0 = quantities?.quantityOptions.filter(quantity => {
      if (!materialOption) {
        return true;
      }
      return quantity >= materialOption.minQuantity && quantity <= materialOption.maxQuantity;
    });
    $[0] = item;
    $[1] = quantitiesForAllProducts;
    $[2] = materialOption;
    $[3] = quantities;
    $[4] = t0;
  } else {
    materialOption = $[2];
    quantities = $[3];
    t0 = $[4];
  }
  const presetQuantities = t0;
  let t1;
  if ($[5] !== isLoading || $[6] !== materialOption || $[7] !== presetQuantities || $[8] !== quantities) {
    t1 = {
      quantities,
      materialOption,
      presetQuantities,
      isLoading
    };
    $[5] = isLoading;
    $[6] = materialOption;
    $[7] = presetQuantities;
    $[8] = quantities;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}